export function InstagramIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className={className}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" strokeWidth="1.7" />
      <circle cx="12" cy="12" r="3.6" strokeWidth="1.7" />
      <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function TikTokIcon({ className = "h-6 w-6" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M14.2 3c.3 2 1.5 3.5 3.5 4V10a6.8 6.8 0 0 1-3.5-1v6a5 5 0 1 1-5-5c.3 0 .6 0 1 .1v2.8a2.3 2.3 0 1 0 1.7 2.2V3h2.3z" />
    </svg>
  );
}
